export default {
  emits: ['close'],

  mounted () {
    document.addEventListener('keydown', this.handleKeydown);
  },

  destroyed () {
    document.removeEventListener('keydown', this.handleKeydown);
  },

  methods: {
    hide () {
      this.$emit('close');
    },

    handleKeydown (event) {
      event = event || window.event;

      if (event.keyCode === 27) {
        this.hide();
      }
    },
  },
};
